import { ReactNode } from 'react';
import { BenefitProps } from './Benefit.type';

const Benefit = ({ benefitTitle, benefitChildren }: BenefitProps) => (
  <div className="benefit-content">
    <h1>{benefitTitle}</h1>
    <div
      className={`benefits ${benefitChildren.length % 3 === 0 ? 'col-3' : ''}`}
    >
      {benefitChildren.map((benefit) => (
        <div className="benefit" key={benefit.title}>
          <div className="icon">{benefit.icon as ReactNode}</div>
          <div className="description">
            <h4>{benefit.title}</h4>
            <span>{benefit.description}</span>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default Benefit;
